import { AbstractControl, FormGroup, FormArray } from "@angular/forms";

export function markAllTouched(control: AbstractControl): void {
    if (control) {
        control.markAsTouched();
        if (control instanceof FormGroup) {
            markGroupTouched(control);
        } else if (control instanceof FormArray) {
            markArrayTouched(control);
        }
    }
}


function markGroupTouched(group: FormGroup): void {
    Object.keys(group.controls || {})
        .map((key: string) => group.controls[key])
        .forEach((child: AbstractControl) => {
            markAllTouched(child);
        });
}

function markArrayTouched(array: FormArray): void {
    (array.controls || []).forEach((child: AbstractControl) => {
        markAllTouched(child);
    });
}